export default __webpack_public_path__ + "5078241b8e853e9b0b3c779314c843d3.png";